module.exports = __webpack_public_path__ + "6157f61558016fc52e290ec73b16e0c4.png";